import { COMMON_ERRORS } from 'modules/common/constants/errors.references';

export const ERROR_REFS = {
  ...COMMON_ERRORS,
  // add new error refs here
};

export const ADDRESS_BOOK_ERRORS = {
  [ERROR_REFS.DUPLICATE_KEY]: {
    title: 'addressBook:errors.duplicatedName',
    description: 'addressBook:errors.duplicatedNameDescription',
  },
};
